var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.4 20.9",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.8.4 3.7 17l-2.3-2.3L0 16.1l4.7 4.8 4.7-4.8L8 14.7 5.7 17 5.8.4z",
  className: "st0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down.3b8bedd175b7fcf0df319a9c46e5b632.svg";